import { BrowserRouter, Route, Routes } from "react-router-dom"
import ImpressumPage from "./ImpressumPage"
import PublicLanding from "./PublicLanding"

const PublicSite = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<PublicLanding />} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="*" element={<PublicLanding />} />
    </Routes>
  </BrowserRouter>
)

export default PublicSite
